import type {AccountApiModel} from '../../../api/account';
import type {ApiListResponse} from '../../../api/types';
import type {CoreUserAccountsAddParams} from '../../../api/types/core/methods';

import {accountStore} from '../../../api/account';
import {apiRequest} from '../../../api/utils/apiRequest';
import {askToFillPrivateProfileIfNeeded} from '../../sync-private-profile';

export const accountAdd = async (params: CoreUserAccountsAddParams) => {
  const account = await accountStore.create(params);

  const {_items: accounts}: ApiListResponse<AccountApiModel> = await apiRequest(
    {
      method: 'user.accounts.list',
    },
  );

  if (accounts.filter(item => item.type === account.type).length === 1) {
    askToFillPrivateProfileIfNeeded({
      [account.type]: account.value,
    });
  }

  return account;
};
